<div class="verify-patient-registration">
    <a class="btn btn-link btn-icon btn-icon--left btn-back" [routerLink]="['/login']">
        {{ 'Go to login page' | translate }}
    </a>
    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header--info">
                    <div class="card--box__header__title">
                        {{ 'Verify export download' | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="card-block card--box__block">
            <div class="row">
                <div class="col-xs-12">
                    <ng-container *ngIf="downloadSuccess">
                        <h2>{{ 'Your file is downloaded' | translate }}</h2>
                    </ng-container>
                    <ng-container *ngIf="errorMessage">
                        <h2>{{ errorMessage | translate }}</h2>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>